/* eslint-disable @tseslint/prefer-nullish-coalescing */
import { NavigationService } from "@core/services/navigation/navigation.service";
import { computed, inject, Signal } from "@angular/core";
import { CurrentEntity, ExtjsActionFn, ResolveUrlFn } from "@core/types/navigation.type";
import { ActionConfigMapping, ExtjsActions } from "@core/types/extjs-action.types";
import { CurrentContextService } from "@core/services/current-context.service";
import { ExtjsService } from "@core/services/extjs/extjs.service";
import { Project } from "@core/types/sidebar.type";


const resolvedUrls: Map<string, string> = new Map<string, string>();

export function getUrlSegments (index: number): Signal<string | null>;
export function getUrlSegments (...indexes: number[]): Signal<Array<string | null>>;
export function getUrlSegments (...indexes: number[]): Signal<string | null> | Signal<Array<string | null>> {
  const navigationService: NavigationService = inject(NavigationService);

  if (indexes.length === 1) {
    // eslint-disable-next-line @tseslint/no-non-null-assertion
    const index: number = indexes[ 0 ]!;

    return computed(() => navigationService.urlSegments()[ index ] || null);
  }

  return computed(() => indexes.map((index: number): string | null => navigationService.urlSegments()[ index ] || null));
}
export function resolveUrlFn (): ResolveUrlFn {
  const navigationService: NavigationService = inject(NavigationService);

  return (path: string | undefined): string | undefined => {
    if (!path) return;

    const paramMap: Map<string, string> = navigationService.getParamMap();
    /* eslint-disable-next-line prefer-named-capture-group */
    const resolvedUrl: string = path.replaceAll(/{(\w+)}/g, (_: string, key: string): string => {
      const resolved: string | undefined = paramMap.get(key);

      return resolved ?? `key-${ key }-not-found`;
    });

    let resolvedUrlSignal: string | undefined = resolvedUrls.get(path);

    if (resolvedUrlSignal) {
      resolvedUrlSignal = resolvedUrl;

      return resolvedUrlSignal;
    }

    resolvedUrls.set(path, resolvedUrl);

    return resolvedUrls.get(path);
  };
}
export function extjsActionFn (): ExtjsActionFn {
  const contextService: CurrentContextService = inject(CurrentContextService);
  const extjsService: ExtjsService = inject(ExtjsService);

  return (action: string | undefined): void => {
    if (!action) return;

    const maybeAction: keyof ActionConfigMapping = action as keyof ActionConfigMapping;

    if (ExtjsActions.includes(maybeAction)) {
      const entity: CurrentEntity = contextService.currenEntity();
      const project: Project | null = entity?.type === "project" ? entity.entity : null;

      extjsService.performAction(maybeAction, project);
    }
  };
}

